<ng-container *ngIf="isRegistered; then registeredUserTemplate else guestUserTemplate"></ng-container>
<ng-template #registeredUserTemplate>
  <div class="orderData-header">
    <span langkey="phOrderData_Username_Announce"></span>
    <p>
      {{webshopOrderDataViewModel.fname}}
    </p>
    <p>
      {{webshopOrderDataViewModel.email}}
    </p>
  </div>
</ng-template>
<ng-template #guestUserTemplate>
  <div class="orderData-header">
    <span langkey="phOrderData_Guest_register_comment"></span>
    <div class="orderData-login-botton-container">
      <div class="ya-webshop-button-container">
        <button mat-flat-button (click)="navigateToRegister()"><span langkey="phLoginDialog_Register"></span></button>
      </div>
      <div class="ya-webshop-button-container">
        <button mat-flat-button (click)="navigateToLogin()"><span langkey="phLoginDialog_Login"></span></button>
      </div>
    </div>
  </div>
</ng-template>
<div class="orderdata-form-container">
  <ng-container *ngIf=" !isRegistered">
    <h3 langkey="phOrderData_Order_As_Guest"></h3>
    <span class="following" langkey="phOrderData_Order_Following_Information"></span>
  </ng-container>
  <!-- Billing address (registered & guest users)-->
  <ng-container *ngIf="showBillingInfo">
    <div class="billing-info-Container">
      <ng-container *ngIf="serviceId !== WebShopMode.OrderToTable && isRegistered">
        <h3 langkey="phOrderData_selectBillAddress"></h3>
      </ng-container>
      <ya-dynamicFormFields #billingFormComponent
        *ngIf="customerInputFieldViewModels && customerInputFieldViewModels.length > 0"
        [customerFieldsConfig]="customerInputFieldViewModels" [initialData]="billingFormInitialData"
        (formStatusChange)="onFormStatusChange()" (formReady)="onDynamicFormReady()">
      </ya-dynamicFormFields>
      <div class="ya-webshop-button-container continue-button">
        <button mat-flat-button
          [disabled]="!billingFormComponent || billingFormComponent && !billingFormComponent.formGroup.valid"
          (click)="onConfirmOrderData()">
          <span langkey="phGlobal_Continue"></span>
        </button>
      </div>
    </div>
  </ng-container>
  <!--Delivery address-->
  <ng-container *ngIf="needDeliveryAddress">
    <ng-container *ngIf="isRegistered then registeredUserAddressTemplate else guestUserAddressTemplate"></ng-container>
    <!--Registered user delivery address-->
    <ng-template #registeredUserAddressTemplate>
      <ng-container *ngIf="!showBillingInfo">
        <div class="ya-expansionpanel address-group-container">
          <h3 langkey="phOrderData_selectAddress"></h3>
          <mat-radio-group class="ya-radio-group-vertical" (change)="onDeliveryAddressChange($event.value)"
            [(ngModel)]="deliveryAddressId">
            <ng-container *ngFor="let deliveryAddress of deliveryAddressList">
              <!-- !temporarily for these customers only CDS 20429, Bavaria Alm 21479, Vapiano 31917 & Lewenslust 26320-->
              <ng-container
                *ngIf="deliveryAddress.value == '-1' && !shouldHideAlternateDeliveryAddress(); then newAddressTemp else deliveryAddressTemp">
              </ng-container>
              <ng-template #newAddressTemp>
                <h3 class="addNewAddress" langkey="phOrderData_selectNewAddress"></h3>
                <mat-radio-button [value]="deliveryAddress.value">
                  <span langkey="phOrderData_addNewAddress"></span>
                </mat-radio-button>
              </ng-template>
              <ng-template #deliveryAddressTemp>
                <mat-radio-button [value]="deliveryAddress.value"
                  [disabled]="deliveryAddress.value == 'disabled' ? true : null">
                  {{deliveryAddress.key}}
                </mat-radio-button>
              </ng-template>
            </ng-container>
          </mat-radio-group>
        </div>
        <div class="ya-expansionpanel" *ngIf="panelOpenState">
          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header collapsedHeight="*" expandedHeight="*">
              <mat-panel-title>
                Abweichende Lieferadresse
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ya-dynamicFormFields #registeredUserDeliveryFormComponent
              *ngIf="addressInputFieldViewModels && addressInputFieldViewModels.length > 0"
              [customerFieldsConfig]="addressInputFieldViewModels" [initialData]="registeredUserDeliveryFormInitialData"
              (formStatusChange)="onFormStatusChange()" (formReady)="onDynamicFormReady()">
            </ya-dynamicFormFields>
          </mat-expansion-panel>
        </div>
        <div class="whebshop-deliveryaddress-wrapper">
          <div class="ya-webshop-button-container continue-button">
            <ng-container
              *ngIf="deliveryAddressId !== '-1' || (deliveryAddressId === '-1' && (dynamicDataInputForm &&dynamicDataInputForm.valid)); then deliveryaddressActiveButton else deliveryaddressDeactiveButton">
            </ng-container>
            <ng-template #deliveryaddressActiveButton>
              <button mat-flat-button (click)="setRegisterdUserDeliveryAddress()"><span
                  langkey="phGlobal_Continue"></span></button>
            </ng-template>
            <ng-template #deliveryaddressDeactiveButton>
              <button mat-flat-button disabled><span langkey="phGlobal_Continue"></span></button>
            </ng-template>
          </div>
        </div>
      </ng-container>
    </ng-template>
    <!-- Guest delivery address -->
    <ng-template #guestUserAddressTemplate>
      <ng-container *ngIf="!showBillingInfo">
        <!-- Delivery : address is already selected-->
        <ng-container *ngIf="isOrderDelivery">
          <div class="guest-delivery-address-label"> <ng-container
              *ngIf="guestDeliveryAddressLabel && guestDeliveryAddressLabel.length > 0">
              <span>{{ guestDeliveryAddressLabel }}</span>
            </ng-container></div>
        </ng-container>
        <!-- Billing address is delivery address (Retail)-->
        <ng-container *ngIf="!isOrderDelivery">
          <ng-container *ngIf="getGuestBillingAddressLabel()">
            <span>{{getGuestBillingAddressLabel() }}</span>
          </ng-container>
          <mat-radio-group [(ngModel)]="deliveryAddressId" (change)="onDeliveryAddressChange(deliveryAddressId)">
            <!--  Billing address is pre elected as delivery address-->
            <div class="radio-content-container ">
              <h3 langkey="phOrderData_Billing_Address_Is_Delivery_Address_Title"></h3>
              <div class="ya-radio-group-vertical">
                <mat-radio-button [checked]="deliveryAddressId===BILLING_ADDRESS_ID" [value]="BILLING_ADDRESS_ID">
                  <span langkey="phOrderData_Billing_Address_Is_Delivery_Address_Label"></span>
                </mat-radio-button>
              </div>
            </div>
            <!-- Select different address -->
            <!-- !temporarily for these customers only CDS 20429, Bavaria Alm 21479, Vapiano 31917 & Lewenslust 26320-->
            <ng-container *ngIf="!shouldHideAlternateDeliveryAddress()">
              <div class="ya-expansionpanel address-group-container guest-address-panel">
                <h3 langkey="phOrderData_Different_Delivery_Address"></h3>
                <div class="ya-radio-group-vertical">
                  <mat-radio-button [value]="DELIVERY_ADDRESS_ID">
                    <span langkey="phOrderData_Enter_Different_Delivery_Address"></span>
                  </mat-radio-button>
                </div>
              </div>
            </ng-container>
          </mat-radio-group>
        </ng-container>
        <!--Toggle address fields-->
        <div class="ya-expansionpanel" *ngIf="panelOpenState">
          <mat-expansion-panel [expanded]="true">
            <ya-dynamicFormFields #guestDeliveryFormComponent
              *ngIf="addressInputFieldViewModels && addressInputFieldViewModels.length > 0"
              [customerFieldsConfig]="addressInputFieldViewModels" [initialData]="guestDeliveryFormInitialData"
              (formStatusChange)="onFormStatusChange()" (formReady)="onDynamicFormReady()">
            </ya-dynamicFormFields>
          </mat-expansion-panel>
        </div>
        <div class="whebshop-deliveryaddress-wrapper">
          <div class="ya-webshop-button-container continue-button">
            <ng-container *ngIf="isOrderDelivery then deliveryValidation else defaultValidation"></ng-container>
            <ng-template #deliveryValidation>
              <button mat-flat-button [disabled]="!hasValue(getGuestBillingAddressLabel())"
                (click)="setGuestDeliveryAddress()"><span langkey="phGlobal_Continue"></span></button>
            </ng-template>
            <ng-template #defaultValidation>
              <ng-container
                *ngIf="deliveryAddressId !== '-1' || (deliveryAddressId === '-1' &&  (dynamicDataInputForm && dynamicDataInputForm.valid)); then deliveryaddressActiveButton else deliveryaddressDeactiveButton">
              </ng-container>
              <ng-template #deliveryaddressActiveButton>
                <button mat-flat-button (click)="setGuestDeliveryAddress()"><span
                    langkey="phGlobal_Continue"></span></button>
              </ng-template>
              <ng-template #deliveryaddressDeactiveButton>
                <button mat-flat-button disabled><span langkey="phGlobal_Continue"></span></button>
              </ng-template>
            </ng-template>
          </div>
        </div>
      </ng-container>
    </ng-template>
  </ng-container>
</div>